import React, {useEffect, useRef, useState} from 'react';
import {Flex} from "antd";
import HighchartsReact from "highcharts-react-official";
import Highcharts from 'highcharts';
import HighchartsMap from "highcharts/modules/map";
// import kazakhstan from "../../../../constants/kz/kz-all.geo.json";
import proj4 from "proj4";
import classes from './style.module.css';
import {clrs} from "../../../../constants/colors";
import IntlMessage from "../../../../components/IntlMessage/IntlMessage";
import {useTranslation} from "react-i18next";
import useKazakhstan from "../../../../constants/kz/useKazakhstan";
HighchartsMap(Highcharts);

const TestPage = () => {
    const chartRef = useRef();
    const {t} = useTranslation();

    const kazakhstan = useKazakhstan();

    // const data = [
    //     ['kz-5085', 0], ['kz-qo', 1], ['kz-ac', 0], ['kz-as', 0],
    //     ['kz-qs', 0], ['kz-nk', 0], ['kz-pa', 0], ['kz-am', 0],
    //     ['kz-zm', 0], ['kz-ek', 0], ['kz-ar', 0], ['kz-mg', 0],
    //     ['kz-aa', 0], ['kz-at', 0], ['kz-wk', 0], ['kz-sk', 0],
    //     ['kz-qg', 0]
    // ]

    const data = [
        {"hc-key" : 'kz-pa'},
        {"hc-key" : 'kz-5085'},
        {"hc-key" : 'kz-qo'},
        // {"hc-key" : 'kz-ac'},
        // {"hc-key" : 'kz-as'},
        {"hc-key" : 'kz-qs'},
        {"hc-key" : 'kz-nk'},
        {"hc-key" : 'kz-pa'},
        {"hc-key" : 'kz-am'},
        {"hc-key" : 'kz-zm'},
        {"hc-key" : 'kz-ek'},
        {"hc-key" : 'kz-ar'},
        {"hc-key" : 'kz-mg'},
        {"hc-key" : 'kz-aa'},
        {"hc-key" : 'kz-at'},
        {"hc-key" : 'kz-wk'},
        {"hc-key" : 'kz-sk'},
        {"hc-key" : 'kz-qg'},
    ]

    const options = {
        chart: {
            map: kazakhstan,
            proj4,
            width: 1000,
            height: 800
        },

        title: {
            text: t('kazakhstan')
        },

        accessibility: {
            typeDescription: t('kazakhstan')
        },

        mapNavigation: {
            enabled: true,
            buttonOptions: {
                verticalAlign: 'bottom'
            }
        },

        tooltip: {
            enabled: false
        },

        colors: [clrs.whiterGreen],

        colorAxis: {
            visible: false
        },

        series: [{
            data: data,
            name: 'Value',
            states: {
                hover: {
                    color: '#93daa9'
                }
            },
            events : {
                click: (e) => {
                    e.point.zoomTo();
                }
            },
            dataLabels: {
                enabled: true,
                style: {
                    textOutline:"none",
                    color: "black",
                    width: 75,
                    align: "center"
                },
                align: "center",
                format: '{point.name}',
            }
        }]
    };

    return (
        <Flex style={{width: "100%", position: "relative"}} align={"flex-start"} justify={"flex-start"} vertical wrap={"wrap"} gap={10}>
            <Flex style={{width: 1000, position: "relative"}} align={"flex-start"} justify={"flex-start"}>
                <HighchartsReact
                    ref={chartRef}
                    constructorType={"mapChart"}
                    highcharts={Highcharts}
                    options={options}
                />
                <div style={{position: "absolute", bottom: 0, right: 10, width: 150, height: 15, backgroundColor: "white"}}></div>
            </Flex>
        </Flex>
    );
};

export default TestPage;